import React, { useState, useEffect } from "react";
import {
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RecordNotFoundNoNotification from "../../../common/RecordNotFoundNoNotification";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useNavigate } from "react-router-dom";
const Spare = (props) => {
    const { notificationRecords, totalElements, handleChangePage, handleChangeRowsPerPage, rowsPerPage, page } = props;
    const [brodcastList, setBrodcastList] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        setBrodcastList(notificationRecords)
    }, [notificationRecords, totalElements, handleChangePage, handleChangeRowsPerPage, rowsPerPage, page])

    return (
        <>
            {brodcastList && brodcastList.length > 0 ? (brodcastList.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
            )).map((row, index) => {
                return (
                    <Accordion sx={{ borderLeft: 7, p: 0, borderColor: "#003f93", mb: 1,textAlign:"left" }} key={row.id}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography sx={{textTransform:"capitalize"}}>{row.title}  </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                {row.content}
                            </Typography>
                            <Typography sx={{ textAlign: "right" }}>
                                <ArrowRightAltIcon
                                    fontSize="large"
                                    sx={{ color: "#003f93", cursor: "pointer" }}
                                    onClick={() => navigate(
                                        `/spare-details-view/${row?.notificationTypeId}`,
                                        {
                                            state: {
                                              pageNo: page,
                                              typeId: 2,
                                              fromNotification:true,
                                              isFromRead : true
                                            },
                                          }
                                    )}
                                />
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                )
            })
                : <RecordNotFoundNoNotification />
            }

        </>
    );
};

export default Spare;
